import React, { useEffect } from 'react';
import './Process.css';

const steps = [
  {
    name: 'Diligence',
    desc: 'Two to four weeks. Architecture review, regulatory mapping, integration audit. Output is a delivery plan with named risks, costed and dated.',
    chips: ['Discovery', 'Risk register', 'Plan']
  },
  {
    name: 'Architect',
    desc: 'Reference architecture, domain model, and a working spike against your real data. Delivered against agreed SLAs and audit requirements before any production code is written.',
    chips: ['Reference arch.', 'Domain model', 'Spike']
  },
  {
    name: 'Build',
    desc: 'Two-week increments, production-grade from day one. Embedded with your team or operating end-to-end. Weekly demos, monthly steerco, full audit trail across every commit and deployment.',
    chips: ['2-wk cadence', 'Production-grade', 'Audit trail']
  },
  {
    name: 'Operate',
    desc: '24/7 cover during cutover and beyond. Knowledge transfer to your engineering team is a deliverable, not an afterthought. We leave when you no longer need us.',
    chips: ['SRE cover', 'Handover', 'SLA']
  }
];

export default function Process() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="section-wrapper--ivory">
      <section className="section shell" id="process">
      <div className="process-grid">
        <div>
          <div className="section-label reveal">03 — Process</div>
          <h2 className="display cap-grid__title reveal" style={{ marginTop: '32px' }}>
            How we<br /><em style={{ color: 'var(--graphite-2)' }}>engage.</em>
          </h2>
          <p className="cap-grid__sub reveal" style={{ color: 'var(--graphite)' }}>
            A four-stage delivery model proven across regulated and consumer environments. Fixed-price discovery, value-based delivery, transparent reporting from week one.
          </p>
        </div>

        <ol className="process-list">
          {steps.map((step, idx) => (
            <li key={idx} className="process-step reveal">
              <span className="process-step__num">{String(idx + 1).padStart(2, '0')}</span>
              <div>
                <h3 className="process-step__name">{step.name}</h3>
                <p className="process-step__desc">{step.desc}</p>
                <div className="process-step__chips">
                  {step.chips.map((chip, i) => (
                    <span key={i} className="process-step__chip">{chip}</span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
      </section>
    </div>
  );
}
